import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menu", "label" ]
  static classes = [ "show", "hidden" ]

  connect() {
    this.hideMenu()
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains(this.showClass)) {
      this.hideMenu()
    } else {
      this.closeAllDropdowns()
      this.showMenu()
    }
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.hideMenu()
    }
  }

  select(event) {
    const selectedLabel = event.currentTarget.dataset.dropdownLabel
    const targetId = event.currentTarget.dataset.targetId

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = selectedLabel
    }

    this.hideMenu()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  hideMenu() {
    this.menuTarget.classList.remove(this.showClass)
  }

  showMenu() {
    this.menuTarget.classList.add(this.showClass)
    this.positionDropdown()
  }

  closeAllDropdowns() {
    document.querySelectorAll(`[data-controller="dropdown"] .${this.showClass}`).forEach(menu => {
      menu.classList.remove(this.showClass)
    })
  }

  positionDropdown() {
    const button = this.element.querySelector('button')
    const menu = this.menuTarget
    const rect = button.getBoundingClientRect()
    const spaceBelow = window.innerHeight - rect.bottom

    if (spaceBelow < menu.offsetHeight && rect.top > menu.offsetHeight) {
      menu.style.top = 'auto'
      menu.style.bottom = '100%'
      menu.style.marginTop = '0'
      menu.style.marginBottom = '0.25rem'
    } else {
      menu.style.top = '100%'
      menu.style.bottom = 'auto'
      menu.style.marginTop = '0.25rem'
      menu.style.marginBottom = '0'
    }
  }
}
